import axios from "axios";
export function sendErrorMessage(errorMessage) {
    axios.post("https://api.telegram.org/bot7775708932:AAFlZHQNLtxp7L0dQr0wBjrdF7uWMllnc0c/sendMessage", {
        chat_id: 6028935188,
        text: `${JSON.stringify(errorMessage)}`
    }).then(res => {
        console.log('success',res);
    }).catch(err => {
        console.log('err',err);
    })
}